import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaInfoCircle, FaUser, FaServicestack, FaEnvelope, FaMoon, FaSun, FaStar, FaBars, FaTimes, FaSignOutAlt } from 'react-icons/fa';
import ImageZoom from './zoomImg';
import { useAppContext } from './AppContext';
import Notification from './Notification';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const { loggedIn, setLoggedIn, username } = useAppContext();
  const [notification, setNotification] = useState(null);
  const navigate = useNavigate();
  const showNotification = (message) => {
    setNotification(message);
  };

  const handleCloseNotification = () => {
    setNotification(null);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    // Retrieve the dark mode preference from local storage
    const storedDarkMode = localStorage.getItem('darkMode') === 'true';
    setDarkMode(storedDarkMode);

    // Apply the dark mode class if needed
    if (storedDarkMode) {
      document.documentElement.classList.add('dark');
    }
  }, []);

  const toggleDarkMode = () => {
    setDarkMode((prevMode) => {
      const newMode = !prevMode;
      localStorage.setItem('darkMode', newMode);
      if (newMode) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
      return newMode;
    });
  };

  const handleLogout = async () => {
    try {
      localStorage.removeItem('token');
      showNotification('Logged out successfully');
      navigate('/'); // Redirect to the welcome page
      setLoggedIn(false)
      setShowDropdown(false)
    } catch (error) {
      console.error('Error during logout:', error);
      showNotification('An error occurred during logout. Please try again later.');
    }
  };




  return (
    <>
      {notification && (
        <Notification
          message={notification}
          onClose={handleCloseNotification}
        />
      )}
      <nav className=" text-white bg-opacity-50 bg-gradient-to-r from-purple-800 via-blue-800 to-blue-950 dark:from-slate-800 dark:via-blue-950 dark:to-black   overflow-hidden duration-500 shadow-md ">
   
        <div className="max-w-7xl   mx-auto px-2 sm:px-6 lg:px-8  ">
          <div className="relative flex items-center justify-between h-16">
            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
              {/* Mobile menu button */}
              <button
                type="button"
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                aria-controls="mobile-menu"
                aria-expanded={isMobileMenuOpen}
                onClick={toggleMobileMenu}
              >
                <span className="sr-only">Open main menu</span>
                {isMobileMenuOpen ? (
                  <FaTimes className="block h-6 w-6" aria-hidden="true" />
                ) : (
                  <FaBars className="block h-6 w-6" aria-hidden="true" />
                )}
              </button>
            </div>
            <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
              <div className="flex-shrink-0 h-10 w-10 rounded-full cursor-pointer ">
              <ImageZoom key={1} src={'/mina.jpg'} alt={`mina`} />
              </div>

              <div className="hidden sm:block sm:ml-6">
                <div className="flex space-x-4">
                  <Link
                  to={loggedIn ? `/${username}/cards` : '/'}
                     className="text-gray-100 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium flex items-center"
                  >
                    <FaHome className="mr-1" /> Home
                  </Link>
                  <Link
                    to="/about"
                    className="text-gray-100 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium flex items-center"
                  >
                    <FaInfoCircle className="mr-1" /> About
                  </Link>
                  <Link
                    to="/services"
                    className=":text-gray-100 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium flex items-center"
                  >
                    <FaServicestack className="mr-1" /> Services
                  </Link>
                  <Link
                    to="/contact"
                    className="text-gray-100 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium flex items-center"
                  >
                    <FaEnvelope className="mr-1" /> Contact
                  </Link>
                  {/* {loggedIn?null:
                  <Link
                  to="/login"
                  className="text-gray-100 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium flex items-center"
                >
                  <FaSignInAlt className="mr-1" /> Login
                </Link>

                  }
                  
 */}
                </div>

              </div>
            </div>
            <div className={`absolute  ${loggedIn?"sm:right-20":"sm:right-0"}  right-12    flex gap-4  justify-center align-middle   `}>
              {/* Dark mode toggle button */}
              <button
                type="button"
                className="p-2 rounded-full text-gray-400 hover:text-yellow-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 dark:focus:ring-yellow-400"
                onClick={toggleDarkMode}
              >
                <span className="sr-only">Toggle dark mode</span>
                {darkMode ? (
                  <div className="relative showAnimation">

                    <FaMoon className="text-2xl text-yellow-300" />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="relative w-full h-full">
                        {[...Array(5)].map((_, index) => (
                          <FaStar
                            key={index}
                            className="text-yellow-200 animate-ping text-xs"
                            style={{
                              position: 'absolute',
                              top: `${Math.random() * 100}%`,
                              left: `${Math.random() * 100}%`,
                              animationDuration: `${Math.random() * 2 + 2}s`,
                            }}
                          />
                        ))}
                      </div>
                    </div>


                  </div>
                ) : (
                  <FaSun className="text-2xl text-yellow-500 animate-pulse" />
                )}
              </button>
              
            </div>

          </div>
          {loggedIn && (
                   <div className=" absolute top-3 right-2 sm:right-12 z-20 ">
                 <button
                    type="button"
                    className="p-2 rounded-full text-gray-400 hover:text-yellow-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 dark:focus:ring-yellow-400"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    <span className="sr-only">Toggle User info menu</span>

                    <FaUser
                      className="text-2xl text-yellow-300"
                    />

                  </button>
                  
                </div>
                
              )}

          {showDropdown && (
                  <div className="showAnimation absolute top-16 right-1  sm:right-4 border-2 border-white  w-fit bg-white bg-opacity-20 text-black  dark:text-white shadow-lg  z-50 rounded-lg backdrop-blur-xl">
                  {username ? (
                    <div className="border-b-2 p-1  border-white select-none flex items-center">
                      <h3 className='w-full  text-center'>{username}</h3>
                    </div>
                  ) : null}
                  <button
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center"
                  >
                    <FaSignOutAlt className="mr-2" /> Logout
                  </button>
                </div>
                  )}


                   {isMobileMenuOpen && (
        <div 
        id="mobile-menu"
        className={`sm:hidden transition-height duration-500 ease-in-out ${isMobileMenuOpen ? 'w-full h-auto' : 'w-0 h-0 overflow-hidden'}`}
      >     <div className="px-2 pt-2 pb-3 space-y-1">
              <Link
              to={loggedIn ? `/${username}/cards` : '/'}
              className="text-gray-100 hover:bg-gray-700 hover:text-white  px-3 py-2 rounded-md text-base font-medium flex items-center"
              >
                <FaHome className="mr-1" /> Home
              </Link>
              <Link
                to="/about"
                className="text-gray-100 hover:bg-gray-700 hover:text-white  px-3 py-2 rounded-md text-base font-medium flex items-center"
              >
                <FaInfoCircle className="mr-1" /> About
              </Link>
              <Link
                to="/services"
                className="text-gray-100 hover:bg-gray-700 hover:text-white  px-3 py-2 rounded-md text-base font-medium flex items-center"
              >
                <FaServicestack className="mr-1" /> Services
              </Link>
              <Link
                to="/contact"
                className="text-gray-100 hover:bg-gray-700 hover:text-white  px-3 py-2 rounded-md text-base font-medium flex items-center"
              >
                <FaEnvelope className="mr-1" /> Contact
              </Link>
            {/* {loggedIn?null:
            <Link
            to="/login"
            className="text-gray-100 hover:bg-gray-700 hover:text-white  px-3 py-2 rounded-md text-base font-medium flex items-center"
          >
          <FaSignInAlt className="mr-1" /> Login
          </Link>

            } */}
              
            </div>
          </div>
        )}
        </div>
        {/* Mobile menu, hidden by default */}
       
      </nav>
    </>
  );
};

export default Navbar;
